module.exports = __webpack_public_path__ + "static/media/accident_icon.c1dfc364.svg";